


























import Vue from 'vue'
import { CodesStatusList } from '../services/procodes-client'

export default Vue.extend({
  name: 'CodesFilter',
  data () {
    return {
      statusList: CodesStatusList,
      status: ''
    }
  },
  methods: {
    applyFilter () {
      if(this.status) {
        const filter = `&status=${this.status}`
        this.$emit('applyFilter', filter)
      } else {
        this.$emit('applyFilter', '')
      }
    }
  }
})
